import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import { counterSignContracts, customers, modals } from 'ducks';
import Placeholder from 'components/Placeholder';

import ModalComponent from '../ModalComponent';
import registeredComponent from '../../utils/registeredComponent';
import duckify, { singleDuck } from '../../utils/duckify';
import { apiFetch } from '../../utils';
import './styles/CounterSignatureModal.scss';

const CounterSignatureModal = ({ ids, customer, dispatch, schoolYearId }) => {
  const [currentPage, setPage] = useState(1);
  const [counterSignatureType, setCounterSignatureType] = useState(null);

  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countersigning, setCountersigning] = useState(false);

  useEffect(() => {
    setLoading(true);
    apiFetch.post({}, '', { contact_ids: ids, school_year_id: schoolYearId }, { baseUrl: '/api/bulk_countersign' })
      .then(({ countersign_contracts }) => {
        setContracts(countersign_contracts);
        setLoading(false);
      });
  }, ids + [schoolYearId]);

  const page1 = () => (
    !loading && contracts.length > 0 ? (
      <div>
        <p>
          You are about to countersign contracts for {contracts.length} {contracts.length !== 1 ? 'contacts' : 'contact'}.
          Please note that contracts can only be countersigned once all required parents/guardians have signed.
        </p>
        <div>
          Completing this action results in the following:
          <ul>
            <li>
              Any contracts in the Pending Countersign state will move to ‘Submitted’ and a downloadable PDF of the completed form
              will become available in the Parent Portal.
            </li>
            <li>
              Any contracts in the Pending Payment state will remain in that state until the
              Deposit has been paid. After payment is received, the contract will move to ‘Submitted’
              and a downloadable PDF of the completed form will become available in the Parent Portal.
            </li>
          </ul>
        </div>
      </div>
    ) : <div>There are no contracts available to countersign.</div>
  );

  const page2 = () => (
    <div>
      <p>Please choose the desired signature type:</p>
      <input
        name='countersignature_type'
        id='countersign_signature'
        onClick={() => setCounterSignatureType('signature')}
        type='radio'
        value='signature'
      />
      <label className='counter-signature-label'>Electronic Signature</label>
      <div className='counter-signature-explanation'>
        Add an electronic signature that will capture your name, admin portal email, IP address and current timestamp.
      </div>
      <input
        name='countersignature_type'
        disabled={!customer.countersign_image_url}
        id='countersign_image'
        onClick={() => setCounterSignatureType('image')}
        type='radio'
        value='image'
      />
      <label className='counter-signature-label'>Image</label>
      <div className='counter-signature-explanation'>
        Use the signature image uploaded on your
        <a target='_blank' href='/setup/enrollment_school_years'>enrollment setup page.</a>
      </div>
      {customer.countersign_image_url ? (
        <img src={customer.countersign_image_url} />
      ) : (
        <div className='alert alert-danger'>
          <FontAwesome className='counter-signature-warning' name='warning' />
          There are no signature images available. Please upload one within the Enrollment Setup page or select the electronic signature method.
        </div>
      )}
    </div>
  );

  const onSubmit = () => {
    setCountersigning(true);
    // The id property here is a hack to get it to hit the right route
    dispatch(
      counterSignContracts.actions.update({
        id: 'countersign',
        contract_ids: contracts.map((c) => c.id),
        counter_signature_type: counterSignatureType
      })
    ).then(() => {
      setCountersigning(false);
      dispatch(modals.actions.hide());
      dispatch(modals.actions.show('MessageModal',
        { message: <p>{contracts.length} {contracts.length !== 1 ? 'contracts' : 'contract'} {contracts.length !== 1 ? 'have' : 'has'} been successfully countersigned.</p> },
        { onClose: window.location.reload() }));
    }).catch(() => {
      setCountersigning(false);
      dispatch(modals.actions.hide());
      dispatch(modals.actions.show('UnexpectedError'));
    });
  };

  let buttonList = [];
  if (contracts.length > 0) {
    if (currentPage === 1) {
      buttonList = [<Button className='btn' disabled={contracts.length < 1} onClick={() => setPage(2)}>Next</Button>];
    } else {
      buttonList = [
        <Button className='btn' onClick={() => setPage(1)}>Back</Button>,
        <Button className='btn' disabled={countersigning} onClick={() => onSubmit()}>Submit</Button>
      ];
    }
  }

  return (
    <ModalComponent title='Countersign Contracts' buttons={buttonList}>
      <Placeholder.loading ready={!loading}>
        {currentPage === 1 ? page1() : page2()}
      </Placeholder.loading>
    </ModalComponent>
  );
};

const mapDucksToProps = () => ({
  customer: singleDuck(customers, 'current')
});


export default registeredComponent('CounterSignatureModal')(duckify(mapDucksToProps))(CounterSignatureModal);
